import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWales = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1735)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.7663 8.35044C20.3372 7.13343 19.1777 6.26089 17.8138 6.26089H15.1305C13.4016 6.26089 12.0001 7.66246 12.0001 9.39135C12.0001 9.9562 12.1504 10.4991 12.4121 10.9566C11.4157 10.9484 10.4935 10.9634 9.91309 10.9566C9.91309 9.74924 9.91309 8.21127 9.91309 7.88947L10.0364 7.76619C10.5898 7.21279 10.4052 6.29047 10.4052 6.29047C10.4052 6.29047 9.48301 6.10602 8.92961 6.65943L8.28465 7.30438H7.56526C5.98042 7.30438 4.69572 8.58913 4.69572 10.1739H6.78268V12.5218C6.78268 12.8652 6.85192 13.1923 6.97703 13.4902L6.26092 14.087H5.21743V13.0435H4.17395V15.1305H8.86961V17.2174H7.82612V18.2609H9.91309V16.1739L10.8696 15.0261H13.1305L14.087 16.1739V17.2174H13.0435V18.2609H17.2174V12.5217C17.2174 11.6573 17.9182 10.9565 18.7826 10.9565C18.8048 10.9565 18.8268 10.9573 18.8489 10.9582C18.8057 10.7909 18.7826 10.6156 18.7826 10.4348C18.7827 9.31687 19.6617 8.4043 20.7663 8.35044ZM15.1305 17.2174V15.0261H15.2175L16.174 16.1739V17.2174H15.1305Z",
				fill: "#D80027"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1735",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgWales;
